import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'core/store';
import {Bookmark, Report} from './models';

interface ReportsMetaState {
  activeReport: Report | null;
  activeBookmark: Bookmark | null;
}

const initialState: ReportsMetaState = {
  activeReport: null,
  activeBookmark: null
};

const reportsMetaSlice = createSlice({
  name: 'reportsMeta',
  initialState,
  reducers: {
    activeReportChanged: (state, action: PayloadAction<Report | null>) => {
      state.activeReport = action.payload;
    },
    clearActiveReport: (state) => {
      state.activeReport = null;
    },
    activeBookmarkChanged: (state, action: PayloadAction<Bookmark | null>) => {
      state.activeBookmark = action.payload;
    },
    clearActiveBookmark: (state) => {
      state.activeBookmark = null;
    },
  },
});

export const { activeReportChanged, clearActiveReport, clearActiveBookmark, activeBookmarkChanged } = reportsMetaSlice.actions;

// Selectors
export const selectActiveReport = (state: RootState) => state.reports.activeReport;
export const selectActiveReportId = (state: RootState) => state.reports.activeReport?.id ?? null;
export const selectActiveBookmark = (state: RootState) => state.reports.activeBookmark;
// Export reducer
export default reportsMetaSlice;
